import { ArrowForward } from '@mui/icons-material'
import { useAccountLeverage } from 'hooks/perp/useAccountLeverage'
import { useAssetsImpactOnLeverage } from 'hooks/perp/useAssetsImpactOnLeverage'
import { memo } from 'react'
import { useAmount, useSelectedToken } from 'store/withdraw/hook'
import { toFixed, w2e } from 'utils/number'
import { AccountImpactItemWrap } from './style'

const AccountLeverage = memo(() => {
  const leverage = useAccountLeverage()
  const amount = useAmount()
  const selectedToken = useSelectedToken()
  const impactLeverage = useAssetsImpactOnLeverage(amount, selectedToken?.name!)

  return (
    <AccountImpactItemWrap>
      <span className="left">Account Leverage:</span>
      <span className="right">
        {`${toFixed(w2e(leverage), 4, { fixed: true })}x`}
        <ArrowForward
          sx={{
            width: 12,
            height: 12,
          }}
        />{' '}
        {`${toFixed(w2e(impactLeverage), 4, { fixed: true })}x`}
      </span>
    </AccountImpactItemWrap>
  )
})

export default AccountLeverage
